module.exports = __webpack_public_path__ + "static/img/tu33.8f89619.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/tu33.png
// module id = PTWJ
// module chunks = 1